module.exports = __webpack_public_path__ + "img/dente med-03.366384c9.svg";